import React from 'react';
import { ChevronDown } from 'lucide-react';

const Hero: React.FC = () => {
  const scrollToAbout = () => {
    const section = document.querySelector('section.py-20.bg-white');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover -z-10"
        style={{ opacity: '0.7' }}
        poster="/assets/images/video-poster.jpg"
        onError={(e) => {
          const target = e.target as HTMLVideoElement;
          target.style.display = 'none';
        }}
      >
        <source 
          src="/assets/video/Background_video_output.webm" 
          type="video/webm"
        />
        <source 
          src="/assets/video/Background_video_output.mp4" 
          type="video/mp4"
        />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent -z-10"></div>
      <div className="container mx-auto px-4 relative z-0">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight animate-[fadeIn_1s_ease-in]">
            Excellence in <span className="text-primary-light">Waterproofing</span> Solutions
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-8 font-light animate-[fadeIn_1s_ease-in_0.3s] opacity-0 fill-mode-forwards">
            Professional waterproofing solutions and applications for construction projects
          </p>
          <button 
            className="bg-primary-light text-white px-8 py-3 rounded-lg text-lg font-medium transition-all duration-300 hover:bg-white hover:text-primary-light animate-[fadeIn_1s_ease-in_0.6s] opacity-0 fill-mode-forwards"
            onClick={scrollToAbout}
          >
            About Us
          </button>
        </div>
      </div>
      
      <button 
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white animate-bounce z-0"
        aria-label="Scroll to About section"
      >
        <ChevronDown size={36} className="stroke-2" />
      </button>
    </section>
  );
};

export default Hero;